import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('NovoDashboardInfo', {
    staticClass: "mb-8"
  }), _c('b-row', {
    staticClass: "px-4"
  }, [_vm.certificadoVencidoMsg ? _c('div', {
    staticClass: "card card-custom bg-light-warning card-stretch gutter-b p-4"
  }, [_c('p', {
    staticClass: "mb-0 font-weight-bolder"
  }, [_c('Warning', {
    attrs: {
      "size": 20
    }
  }), _vm._v(" " + _vm._s(_vm.certificadoVencidoMsg) + " "), _c('strong', [_c('a', {
    attrs: {
      "href": "https://wa.me/554935500600?text=Quero saber mais sobre o certificado digital!",
      "target": "_blank"
    }
  }, [_vm._v(" Clique Aqui")])])], 1)]) : _vm._e()]), _c('b-row', {
    staticClass: "px-4 blinking-row"
  }, [_vm.licenca.apresentar_renovacao ? _c('div', {
    staticClass: "card card-custom bg-light-danger card-stretch gutter-b p-4"
  }, [_c('p', {
    staticClass: "mb-0 font-weight-bolder"
  }, [_c('Warning', {
    attrs: {
      "size": 20
    }
  }), _vm._v(" Sua assinatura está prestes a vencer nos próximos dias, realize a sua renovação automaticamente: "), _c('strong', [_c('a', {
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'assinatura'
        });
      }
    }
  }, [_vm._v(" Para realizar a renovação agora, clique aqui! ")])])], 1)]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-custom bg-light-warning card-stretch gutter-b",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'produtosLista'
        });
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-success"
  }, [_c('Estoque', {
    attrs: {
      "size": 16
    }
  })], 1), _c('span', {
    staticClass: "card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 mt-6 d-block"
  }, [_vm._v(_vm._s(_vm.totalProdutosDashboard))]), _c('span', {
    staticClass: "font-weight-bold font-size-sm dashboard-produtos-title",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('b-dropdown', {
    attrs: {
      "variant": "link",
      "toggle-class": "p-0 text-secondary font-weight-bold dashboard-title-dropdown",
      "menu-class": "dashboard-title-menu",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "dashboard-title-label",
          class: {
            'dashboard-title-label-sm': _vm.produtoSelecionado === 'produtos_estoque'
          }
        }, [_vm._v(" " + _vm._s(_vm.produtoSelecionadoLabel) + " ")]), _c('b-icon', {
          staticClass: "dashboard-title-icon",
          attrs: {
            "icon": "chevron-down"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    attrs: {
      "active": _vm.produtoSelecionado === 'produtos'
    },
    on: {
      "click": function click($event) {
        _vm.produtoSelecionado = 'produtos';
      }
    }
  }, [_vm._v(" Produtos ")]), _c('b-dropdown-item', {
    attrs: {
      "active": _vm.produtoSelecionado === 'produtos_estoque'
    },
    on: {
      "click": function click($event) {
        _vm.produtoSelecionado = 'produtos_estoque';
      }
    }
  }, [_vm._v(" Produtos em Estoque ")])], 1)], 1)])])]), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-custom bg-light-warning card-stretch gutter-b",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'pessoasLista'
        });
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-danger"
  }, [_c('Pessoas', {
    attrs: {
      "size": 16
    }
  })], 1), _c('span', {
    staticClass: "card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 mt-6 d-block"
  }, [_vm._v(_vm._s(_vm.totais.pessoas))]), _c('span', {
    staticClass: "font-weight-bold font-size-sm"
  }, [_vm._v("Pessoas")])])])]), _vm.userAccessStore.access.financeiro && _vm.licenca.id_plan !== '7' ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-custom bg-radial-gradient-success card-stretch gutter-b",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'contasReceber'
        });
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-success"
  }, [_c('Financeiro', {
    attrs: {
      "size": 16
    }
  })], 1), _c('span', {
    staticClass: "card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 mt-6 d-block"
  }, [_vm._v("R$ " + _vm._s(_vm.numberToReal(_vm.totais.totalReceber, 2)))]), _c('span', {
    staticClass: "font-weight-bold font-size-sm"
  }, [_vm._v("Contas a receber do dia")])])])]) : _vm._e(), _vm.userAccessStore.access.financeiro && _vm.licenca.id_plan !== '7' ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-custom bg-radial-gradient-danger card-stretch gutter-b",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'contasPagarLista'
        });
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-warning"
  }, [_c('Financeiro', {
    attrs: {
      "size": 16
    }
  })], 1), _c('span', {
    staticClass: "card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 mt-6 d-block"
  }, [_vm._v("R$ " + _vm._s(_vm.numberToReal(_vm.totais.totalPagar, 2)))]), _c('span', {
    staticClass: "font-weight-bold font-size-sm"
  }, [_vm._v("Contas a pagar do dia")])])])]) : _vm._e(), _vm.userAccessStore.access.financeiro && _vm.licenca.id_plan !== '7' ? _c('div', {
    staticClass: "col-xl-6"
  }, [_c('div', {
    class: _vm.resumo.saldo > 0 ? 'card card-custom bg-radial-gradient-success gutter-b' : 'card card-custom bg-radial-gradient-danger gutter-b',
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('div', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    staticClass: "card-header border-0 py-5",
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center",
      "justify-content": "space-between",
      "width": "100%"
    },
    on: {
      "click": function click() {
        return _vm.isSpanded = !_vm.isSpanded;
      }
    }
  }, [_c('h3', {
    staticClass: "card-title font-weight-bolder text-white"
  }, [_vm._v(" Resumo Financeiro ")]), _c('span', {
    staticClass: "svg-icon svg-icon-2x",
    staticStyle: {
      "color": "white"
    }
  }, [!_vm.isSpanded ? _c('Expand', {
    attrs: {
      "size": 16
    }
  }) : _c('Minimize', {
    attrs: {
      "size": 16
    }
  })], 1)]), _c('b-collapse', {
    staticClass: "p-0",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "accordion-2",
      "visible": true,
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "bg-white card-rounded",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'financeiroLista'
        });
      }
    }
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col px-8 py-6 mr-8"
  }, [_c('div', {
    staticClass: "font-size-sm text-muted font-weight-bold"
  }, [_vm._v(" Receitas ")]), _c('div', {
    staticClass: "font-size-h5 font-weight-bolder text-success"
  }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.resumo.receita, 2)) + " ")])]), _c('div', {
    staticClass: "col px-8 py-6"
  }, [_c('div', {
    staticClass: "font-size-sm text-muted font-weight-bold"
  }, [_vm._v(" Despesas ")]), _c('div', {
    staticClass: "font-size-h5 font-weight-bolder text-danger"
  }, [_vm._v(" R$ -" + _vm._s(_vm.numberToReal(_vm.resumo.despesa, 2)) + " ")])])]), _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col px-8 py-8 mr-8"
  }, [_c('div', {
    staticClass: "font-size-sm text-muted font-weight-bold"
  }, [_vm._v(" Saldo atual ")]), _c('div', {
    staticClass: "font-size-h1 font-weight-bolder"
  }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.resumo.saldo, 2)) + " ")])])])])])], 1)]) : _vm._e(), _c('div', {
    staticClass: "col-md-2"
  }, [_vm.userAccessStore.access.prospect && _vm.licenca.id_plan !== '7' ? _c('div', {
    staticClass: "card-custom bg-light-warning card-stretch gutter-b",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'linkProspect'
        });
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-warning"
  }, [_c('ArrowRight', {
    attrs: {
      "size": 16
    }
  })], 1), _c('span', {
    staticClass: "font-weight-bold font-size-lg"
  }, [_vm._v("Atendimento")])])]) : _vm._e(), _vm.userAccessStore.access.nfe ? _c('div', {
    staticClass: "card-custom bg-light-warning card-stretch gutter-b",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'nfeNova'
        });
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-warning"
  }, [_c('ArrowRight', {
    attrs: {
      "size": 16
    }
  })], 1), _c('span', {
    staticClass: "font-weight-bold font-size-lg"
  }, [_vm._v("NFe")])])]) : _vm._e()]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm.userAccessStore.access.vendas ? _c('div', {
    staticClass: "card-custom bg-light-warning card-stretch gutter-b",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'vendasNovo'
        });
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-warning"
  }, [_c('ArrowRight', {
    attrs: {
      "size": 16
    }
  })], 1), _c('span', {
    staticClass: "font-weight-bold font-size-lg"
  }, [_vm._v("NFCe")])])]) : _vm._e(), _vm.userAccessStore.access.orcamento && _vm.licenca.id_plan !== '7' ? _c('div', {
    staticClass: "card-custom bg-light-warning card-stretch gutter-b",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'orcamentoNovo'
        });
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-warning"
  }, [_c('ArrowRight', {
    attrs: {
      "size": 16
    }
  })], 1), _c('span', {
    staticClass: "font-weight-bold font-size-lg"
  }, [_vm._v("Orçamentos")])])]) : _vm._e()]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm.userAccessStore.access.pedidos && _vm.licenca.id_plan !== '7' ? _c('div', {
    staticClass: "card-custom bg-light-warning card-stretch gutter-b",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'pedidosNovo'
        });
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-warning"
  }, [_c('ArrowRight', {
    attrs: {
      "size": 16
    }
  })], 1), _c('span', {
    staticClass: "font-weight-bold font-size-lg"
  }, [_vm._v("Pedidos")])])]) : _vm._e(), _vm.userAccessStore.access.nfse ? _c('div', {
    staticClass: "card-custom bg-light-warning card-stretch gutter-b",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'nova-nfseServicos'
        });
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-warning"
  }, [_c('ArrowRight', {
    attrs: {
      "size": 16
    }
  })], 1), _c('span', {
    staticClass: "font-weight-bold font-size-lg"
  }, [_vm._v("NFSe")])])]) : _vm._e()])]), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-6"
  }, [_c('div', {
    staticClass: "card card-custom bgi-no-repeat gutter-b card-stretch",
    staticStyle: {
      "background-position": "right top",
      "background-size": "40% auto",
      "background-image": "url(media/svg/shapes/abstract-3.svg)"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('a', {
    staticClass: "card-title font-weight-bold text-success text-hover-primary font-size-h5"
  }, [_vm._v("Aniversariantes do dia: " + _vm._s(_vm.hoje))]), _c('div', [_c('TableApp', {
    ref: "nome",
    attrs: {
      "item": "aniversariante",
      "subTitulo": "",
      "data": _vm.aniversariantes,
      "fields": _vm.fields,
      "classFilterColumn": "nome"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'nome' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.nome) + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [props.rowData.telefone ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.righttop",
            value: 'Encaminhar os parabéns para o aniversariante',
            expression: "\n                              'Encaminhar os parabéns para o aniversariante'\n                            ",
            modifiers: {
              "righttop": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-hover-success btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.shareToWhatsapp(props.rowData);
            }
          }
        }, [_c('Whatsapp', {
          attrs: {
            "size": 20
          }
        })], 1) : _c('p', [_vm._v("Sem WhatsApp")])])])])]) : _vm._e()];
      }
    }])
  })], 1)])])])])]), _c('SendToWppModal', {
    attrs: {
      "data": _vm.dataToWhatsapp,
      "openModal": _vm.wppOpenModal,
      "module": "aniversariante"
    },
    on: {
      "handleOpenModal": function handleOpenModal(openModal) {
        return _vm.wppOpenModal = openModal;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };